import type { NavigationScreen } from 'app/types/navigation';
import { usePageTitle, useUISize } from 'app/utils/web-helpers';
import React, { useEffect } from 'react';
import { LandingPageScreen as LandingPageScreenLarge } from './index.large';
import { LandingPageScreen as LandingPageScreenSmall } from './index.small';
import { useLandingPageSetup } from './use-landing-page-setup';
import { FeaturePresentationPrompt } from './components/feature-presentation-prompt';

export const LandingPageScreen: NavigationScreen<'landing-page'> = ({ ...rest }) => {
  const { isSmallUI } = useUISize();
  const setPageTitle = usePageTitle('billboard');
  useEffect(() => setPageTitle('tabBarLabel'), [setPageTitle]);
  const { canPresentFeature } = useLandingPageSetup({ navigation: rest.navigation });

  return (
    <>
      {isSmallUI ? <LandingPageScreenSmall {...rest} /> : <LandingPageScreenLarge {...rest} />}
      <FeaturePresentationPrompt startupReady={canPresentFeature} />
    </>
  );
};
